import { urlsAreEqual, getUrl } from './urlUtils';
// Whether to render a nav item or not
export function shouldRenderNavItem({ item, loggedIn = false, cartCount = 0 }) {
    if (!item) {
        return false;
    }
    if (item?.props?.hideWhenLoggedIn && loggedIn) {
        return false;
    }
    if (item?.props?.hideWhenLoggedOut && !loggedIn) {
        return false;
    }
    if (item?.props?.hideWhenCartEmpty && cartCount === 0) {
        return false;
    }
    if (item?.props?.hideWhenCartNotEmpty && cartCount !== 0) {
        return false;
    }
    return true;
}
// Whether to show a CTA in the CtaSubnav
export function shouldRenderCta({ primaryCtaButton, showCtaOnCtaPage, currentUrl = getUrl(), loggedIn = false, cartCount = 0, }) {
    return (Boolean(primaryCtaButton) &&
        // CTA is not filtered out by logged in or cart state
        shouldRenderNavItem({
            item: primaryCtaButton,
            loggedIn,
            cartCount,
        }) &&
        // CTA should not be hidden due to current URL
        (showCtaOnCtaPage || !urlsAreEqual(primaryCtaButton.props.url, currentUrl)));
}
// Whether to show a Secondary CTA in the CTASubnav
export function shouldRenderSecondaryCta({ secondaryCtaButton, loggedIn = false, cartCount = 0 }) {
    return (Boolean(secondaryCtaButton) &&
        // CTA is not filtered out by logged in or cart state
        shouldRenderNavItem({
            item: secondaryCtaButton,
            loggedIn,
            cartCount,
        }));
}
// Filter an array of nav items
export function filterNavItems({ items = [], loggedIn = false, cartCount = 0 }) {
    if (!items) {
        return [];
    }
    return items.filter((item) => shouldRenderNavItem({
        item,
        loggedIn,
        cartCount,
    }));
}
